import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';

export class Vendor {
  id?: number;
  company?: string;
  ien?: string;
  email?: string;
  phone?: string;
  address?: string;
  date_of_hire?: Date | string;
  status?: string;
  avatar?: string;
  contract_type?: string;
  location_id?: number;
  position_id?: string;
  biweekly_rate?: number;
  weekly_rate?: number;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date | null;

  constructor(data?: Partial<Vendor>) {
    Object.assign(this, data);
  }

  static build(data: Vendor): Vendor {
    return new Vendor({
      id: NumberOrNullOrUndefined(data.id),
      company: StringOrNullOrUndefined(data.company),
      ien: StringOrNullOrUndefined(data.ien),
      email: StringOrNullOrUndefined(data.email),
      phone: StringOrNullOrUndefined(data.phone),
      address: StringOrNullOrUndefined(data.address),
      date_of_hire: StringOrNullOrUndefined(data.date_of_hire),
      status: StringOrNullOrUndefined(data.status),
      avatar: StringOrNullOrUndefined(data.avatar),
      contract_type: StringOrNullOrUndefined(data.contract_type),
      location_id: NumberOrNullOrUndefined(data.location_id),
      position_id: StringOrNullOrUndefined(data.position_id),
      biweekly_rate: NumberOrNullOrUndefined(data.biweekly_rate),
      weekly_rate: NumberOrNullOrUndefined(data.biweekly_rate),
      created_at: data.created_at ? new Date(data.created_at) : undefined,
      updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
      deleted_at: data.deleted_at ? new Date(data.deleted_at) : null,
    });
  }
}
